import { ref, watch } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';

export const useValidation = (modelValue, options = {}) => {

    
    const storeField = useFieldsStore();   

    const isValid = ref(false);
    const isTouched = ref(false);
    const textError = ref(null);
    const formPassword = ref(null);
    
    const validation = (field, rawValue = modelValue.value) => {
        isTouched.value = true;

        if(field === 'firstName'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите Имя, Фамилию и Отчество';
            storeField.updateFields('firstName', 'disabledBtn', isValid.value);
        }

        if(field === 'lastName'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите Фамилию';
            storeField.updateFields('lastName', 'disabledBtn', isValid.value);
            
        }

        if(field === 'restaurant'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите название ресторана';
            storeField.updateFields('restaurant', 'disabledBtn', isValid.value);
            
        }

        if(field === 'city'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите город';
            storeField.updateFields('city', 'disabledBtn', isValid.value);
            
        }

        if(field === 'restaurant_address'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите адрес ресторана';
            storeField.updateFields('restaurant_address', 'disabledBtn', isValid.value);
            
        }

        if(field == 'phone'){
            
            const cleanNumber = rawValue.replace(/\D/g, '').slice(0, 11)
			isValid.value = cleanNumber.length === 11
			textError.value = isValid.value ? '' : 'Введите номер телефона'
			storeField.updateFields('phone', 'disabledBtn', isValid.value)
        }

        if (field === 'email') {
            const emailPattern = /^(?![._%+\-])([A-Za-z0-9._%+\-]{1,})@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
            isValid.value = emailPattern.test(modelValue.value) && modelValue.value.length >= 5;
            textError.value = isValid.value ? '' : 'Введите email';
            storeField.updateFields('email', 'disabledBtn', isValid.value);
        }

        if(field === 'rules'){
            isValid.value = modelValue.value;
            storeField.updateFields('rules', 'disabledBtn', isValid.value);
        }

        if(field === 'agreement'){
            isValid.value = modelValue.value;
            storeField.updateFields('agreement', 'disabledBtn', isValid.value);
        }

        if(field === 'advertising'){
            isValid.value = modelValue.value;
            storeField.updateFields('advertising', 'disabledBtn', isValid.value);
        }

        if(field === 'category'){
            isValid.value = modelValue.value !== '';
            storeField.updateFields('category', 'disabledBtn', isValid.value);
        }

        if(field == 'password'){
            const raw = modelValue.value ?? ''; 
            const password = raw.trim();
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
            isValid.value = regex.test(password);
            formPassword.value = modelValue.value;
            textError.value = isValid.value 
                ? '' 
                : 'Пароль должен содержать минимум 8 символов, включая хотя бы одну заглавную букву, одну строчную букву, одну цифру и один специальный символ.';
            
            storeField.updateFields('password', 'disabledBtn', isValid.value);
        }
        if(field == 'passwordRepeat'){
            const raw = modelValue.value ?? ''; 
            const originalPassword = options?.originalPassword?.value || '';
            isValid.value = raw.trim().length >= 8 && raw === originalPassword;
            textError.value = isValid.value ? '' : 'Повторите пароль';
            storeField.updateFields('passwordRepeat', 'disabledBtn', isValid.value);
        }
        if(field == 'id'){            
            const raw = modelValue.value ?? ''; 
            isValid.value = modelValue.value !== null;
            storeField.updateFields('select', 'disabledBtn', isValid.value);
        }
        if(field === 'message'){
            isValid.value = modelValue.value?.trim().length >= 5;
            textError.value = isValid.value ? '' : 'Введите описание';
            storeField.updateFields('message', 'disabledBtn', isValid.value);
        }

        if(field === 'about_myself'){
            isValid.value = modelValue.value?.trim().length >= 5;
            textError.value = isValid.value ? '' : 'Введите описание';
            storeField.updateFields('about_myself', 'disabledBtn', isValid.value);
        }

        if(field === 'reason'){
            isValid.value = modelValue.value?.trim().length >= 5;
            textError.value = isValid.value ? '' : 'Введите причину';
            storeField.updateFields('reason', 'disabledBtn', isValid.value);
        }
    }
   
    return {
        validation,

        isTouched,
        isValid,
        textError,
    }
}